import io from "socket.io-client";
import { SOCKET_URL } from "./config/constants";

const socket = io(SOCKET_URL, {
  path: "/video-call-server/socket.io",
  transports: ["polling"],
});

const authenticate = () => {
  const token = localStorage.getItem("token");
  if (token) socket.emit("authenticate", token);
};

socket.on("connect", authenticate);

export default socket;
